import { Signal } from "./signal.js";
/**
 * Library-neutral state. This is intentionally minimal: the voice-core
 * only needs a small number of cross-cutting signals (WASM status, the
 * mic-gain probe suggestion, and a neutral listening indicator). Consumer
 * apps keep their own, richer store and do NOT depend on this one.
 */
export const store = {
    usingWasm: new Signal(false),
    suggestedEnergyScale: new Signal(null),
    listening: new Signal(false),
};
